import Vue from 'vue'
import {ClientsResource, getWithPagination} from '../../util/api'

const initialState = {
  objects: {},
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_CLIENTS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_CLIENT (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    CREATED_CLIENT (state, object) {
      state.createdObject = object
    },
    UPDATED_CLIENT (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_CLIENT_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    CREATE_CLIENT_IN_PROGRESS (state, value) {
      state.createInProgress = value
    },
    UPDATE_CLIENT_IN_PROGRESS (state, value) {
      state.updateInProgress = value
    },
    DELETE_CLIENT_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    CLIENTS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  actions: {
    getClient ({ commit }, id) {
      // Check if we have an up-to-date version of the object. If not, get it.
      try {
        commit('GET_CLIENT_IN_PROGRESS', true)
        ClientsResource.get({id: id}).then((response) => {
          commit('GET_CLIENT_IN_PROGRESS', false)
          commit('SET_CLIENT', response.body)
        }, () => {
          // @TODO: Implement error handling
        })
      } catch (ex) {
        // Request was most likely cancelled due to existing in flight request
      }
    },

    getClients ({ commit }, params) {
      commit('GET_CLIENT_IN_PROGRESS', true)
      getWithPagination(ClientsResource, params, response => {
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_CLIENTS', response.body.data)
      }, () => {
        commit('GET_CLIENT_IN_PROGRESS', false)
      }, () => {
        commit('GET_CLIENT_IN_PROGRESS', false)
      })
    },

    createClient ({ commit }, object) {
      // Create (POST) a CLIENT
      commit('CREATED_CLIENT', null)
      commit('CREATE_CLIENT_IN_PROGRESS', true)
      ClientsResource.save({}, object).then((response) => {
        commit('CREATE_CLIENT_IN_PROGRESS', false)
        commit('CREATED_CLIENT', response.body)
        commit('SET_CLIENT', response.body)
      }, () => {
        console.error('Create CLIENT Failed')
        commit('CREATE_CLIENT_IN_PROGRESS', false)
        commit('CREATED_CLIENT', null)
      })
    },

    updateClient ({ commit }, object) {
      // Update (PUT) a CLIENT
      commit('UPDATED_CLIENT', null)
      commit('UPDATE_CLIENT_IN_PROGRESS', true)
      ClientsResource.update({id: object.id}, object).then((response) => {
        commit('UPDATE_CLIENT_IN_PROGRESS', false)
        commit('UPDATED_CLIENT', response.body)
        commit('SET_CLIENT', response.body)
      }, () => {
        commit('UPDATE_CLIENT_IN_PROGRESS', false)
        commit('UPDATED_CLIENT', null)
      })
    },

    clearAll ({ commit }) {
      commit('CLIENTS_CLEAR_ALL')
    }
  }
}
